//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('discGrpCustLangs', {
//        templateUrl: 'views/components/views/discGrpCustLangs/discGrpCustLangs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'discGrpCustLangsService', function ($stateParams, stateService, discGrpCustLangsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let discGrpCustKeyno = $stateParams.discgrpcust_keyno;

//            vm.model = {
//                inputListLanguages: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadLanguages() {
//                vm.model.inputListLanguages = await discGrpCustLangsService.listLanguages({ discgrpcust_keyno: discGrpCustKeyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS
            
//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                discGrpCustLangsService.saveObj({ records: vm.model.inputListLanguages }).then(function () {
//                    stateService.back();
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//            	loadLanguages();
//            }

//            // #endregion ON INIT FUNCTION
//        }]
//    });
//})();
